<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-content class="backgroundcolordark">
    <v-layout>
      <v-img src="static/edologic_Background_Title.png" min-height="594px">
        <v-layout fill-height>
          <v-container>
            <v-layout pa-2 row wrap class="lightbox white--text hidden-xs-only">
              <v-flex xs12 sm12 md12 lg12 text-xs-center>
                <div class="display-3 font-weight-bold">
                  individuell. logisch.<br>
                  <span itemprop="name">edologic.</span>
                </div>
                <div class="headline font-weight-light white--text mt-3">
                  Geniale Projekte beginnen hier
                </div>
              </v-flex>
            </v-layout>
            <v-layout pa-2 row wrap class="lightbox white--text hidden-sm-and-up">
              <v-flex xs12 sm12 md12 lg12 text-xs-center>
                <div class="display-1 font-weight-bold">
                  individuell. logisch.<br>
                  <span itemprop="name">edologic.</span>
                </div>
                <div class="headline font-weight-light white--text mt-3">
                  Geniale Projekte beginnen hier
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-img>
    </v-layout>
    <v-layout>
      <v-container>
        <v-layout row class="ma-5">
          <v-flex xs12>
            <v-card dark tile flat color="transparent" class="text-xs-center">
              <v-card-text class="display-3 font-weight-bold">Unser Service</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <div itemscope itemtype="http://schema.org/Service">
              <meta itemprop="serviceType" content="Softwareentwicklung" />
              <v-card dark tile flat color="transparent" class="text-xs-center">
                <v-dialog
                  v-model="dialog"
                  width="1000"
                  scrollable
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      flat
                      icon
                      color="transparent"
                      large
                      v-on="on"
                      class="mb-5"
                    >
                      <v-icon class="largeicon">important_devices</v-icon>
                    </v-btn>
                  </template>

                  <v-card color="#000012">
                    <v-card-title
                      class="display-3 white--text font-weight-bold text-xs-center"
                    ><v-img src="static/Softwareentwicklung.jpg" max-height="300px">
                      <v-container fill-height>
                        <v-layout align-center>
                          <!-- Horizontal: text-xs-center -->
                          <v-flex xs12 text-xs-center>
                            Individuelle Softwareentwicklung
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-img>
                    </v-card-title>
                  <v-card-text class="white--text headline">
                    <span itemprop="description">
                    Durch unsere innovativen Fertigkeiten verwirklichen wir Ihre individuelle Softwarelösung – perfekt
                    auf Sie abgestimmt.
                    <br><br>
                    Die edologic ist immer darauf bedacht, Sie mit Ihren Produkten optimal zu unterstützen, in dem Sie
                    ökonomische und bedienungsfreundlicher arbeiten können.
                    <br><br>
                    Um Sie von Anfang an perfekt zu betreuen, beginnt jede Entwicklung mit einer sorgfältigen
                    Anforderungsanalyse.
                    <br><br>
                    Mit der edologic können Sie zu jeder Zeit auf Umwelteinflüsse reagieren und agieren, denn unser
                    langjähriges Experten Team steht Ihnen zur Seite und setzt Ihre Anpassungen flexibel, schnell und
                    zielorientiert um.
                    <br><br>
                    Starten Sie mit der edologic durch und erhalten die Software, die auf Sie maßgeschneidert ist und
                    nicht nur zu Ihnen passt.
                      </span>
                    <v-layout row wrap justify-center class="mt-3">
                      <v-flex xs6 sm3>
                        • Java<br>
                        • Vue<br>
                        • .NET Framework<br>
                        • ASP.NET<br>
                        • C#<br>
                        • Cappuccino<br>
                        • u.v.m. ...
                      </v-flex>
                      <v-flex xs6 sm3>
                        • CSS<br>
                        • HTML<br>
                        • JavaScript<br>
                        • MS SQL<br>
                        • MySQL<br>
                        • Orient DB
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="white"
                        flat
                        @click="dialog = false"
                      >
                        Schliessen
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-layout justify-center>
                  <v-flex xs6>
                    <div class="borderedo"></div>
                  </v-flex>
                </v-layout>
                <v-card-text class="title">Individuelle Softwarelösung</v-card-text>
                <v-btn
                  flat
                  color="white"
                  large
                  @click="dialog=true"
                  class="mb-5 text-none"
                > Mehr Wissen
                </v-btn>
              </v-card>
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <div itemscope itemtype="http://schema.org/Service">
              <meta itemprop="serviceType" content="Kreation"/>
              <v-card dark tile flat color="transparent" class="text-xs-center">
                <v-dialog
                  v-model="dialog2"
                  width="1000"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      flat
                      icon
                      color="transparent"
                      large
                      v-on="on"
                      class="mb-5"
                    >
                      <v-icon class="largeicon">format_color_fill</v-icon>
                    </v-btn>
                  </template>
                  <v-card color="#000012">
                    <v-card-title
                      class="display-3 white--text font-weight-bold text-xs-center"
                    ><v-img src="static/kreation.jpg" max-height="300px">
                      <v-container fill-height>
                        <v-layout align-center>
                          <!-- Horizontal: text-xs-center -->
                          <v-flex xs12 text-xs-center>
                            Kreation
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-img>
                    </v-card-title>
                    <v-card-text class="white--text headline">
                    <span itemprop="description">
                     Kreative Projekte beginnen, wo normale enden, denn die edologic weiß, dass Gestaltung ein zielgerichteter Denkprozess ist.
                    <br><br>
                    Um intelligente Lösungen zu schaffen verbinden wir die Kreativität in der Idee un die Professionalität in der Umsetzung. Mit Ihren Input und unserem Know-How bringen wir Ihre Marketingmaßnahme erfolgreich ins Ziel.
                    <br><br>
                    Die edologic ist zum einem Ihr verlässlicher Partner, wenn es um die technische und handwerkliche Kompetenz geht und zum anderem der Partner, der ein breites Spektrum an konzeptioneller Kreativität bietet. Egal ob Webdesign, Retuschen oder Printdesign unser Grafiker-Team ist die richtige Wahl, denn wir greifen neue Trends und Geschmäcker auf, um nachhaltige Marketingziele zu erreichen.
                      </span>
                      <v-layout row wrap justify-center class="mt-3">
                        <v-flex xs6 sm3>
                          • Webdesign <br>
                          • Retuschen <br>
                          • Printdesign <br>
                          • …
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="white"
                        flat
                        @click="dialog2 = false"
                      >
                        Schliessen
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-layout justify-center>
                  <v-flex xs6>
                    <div class="borderedo"></div>
                  </v-flex>
                </v-layout>
                <v-card-text class="title">Kreation</v-card-text>
                <v-btn
                  flat
                  color="white"
                  large
                  @click="dialog2=true"
                  class="mb-5 text-none"
                > Mehr Wissen
                </v-btn>
              </v-card>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-5">
          <v-flex xs12 sm6>
            <div itemscope itemtype="http://schema.org/Service">
              <meta itemprop="serviceType" content="Hosting" />
              <v-card dark tile flat color="transparent" class="text-xs-center">
                <v-dialog
                  v-model="dialog3"
                  width="1000"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      flat
                      icon
                      color="transparent"
                      large
                      v-on="on"
                      class="mb-5"
                    >
                      <v-icon class="largeicon">dns</v-icon>
                    </v-btn>
                  </template>
                  <v-card color="#000012">
                    <v-card-title
                      class="display-3 white--text font-weight-bold text-xs-center"
                    ><v-img src="static/rechenzentrum.jpg" max-height="300px">
                      <v-container fill-height>
                        <v-layout align-center>
                          <!-- Horizontal: text-xs-center -->
                          <v-flex xs12 text-xs-center>
                            Hosting
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-img>
                    </v-card-title>
                    <v-card-text class="white--text headline">
                    <span itemprop="description">
                      Datenintegrität – ein Indikator für Geborgenheit.
                    <br><br>
                    Um Ihnen das Gefühl der Geborgenheit zu ermöglichen, bietet Ihnen die edologic innovative
                    Dienstleistungen in einem Rechenzentrum mit idealem Standort in Düsseldorf an.
                    Die Positionierung des Rechenzentrums bietet den Vorteil, dass Ihre Daten dem deutschen Datenschutz
                    unterliegen. Die eigene Infrastruktur ermöglicht es, Ihnen eine geringe Ausfallwahrscheinlichkeit zu
                    bieten und die Störfälligkeit auf ein Minimum herabzusetzen.
                    </span>
                      <v-layout row wrap justify-space-around class="mt-3">
                        <v-flex xs6 sm5>
                          Darüber hinaus hält das Rechenzentrum noch viele weitere Vorteile für Sie bereit:
                          <br><br>
                          • ISO 27001 Zertifizierung<br>
                          • Tier 3 Standard<br>
                          • 24/7 Betriebsüberwachung mit Weiterleitung an Techniker<br>
                          • 24/7 Videoüberwachung des kompletten Geländes und der Gebäude<br>
                          • 24/7 Objektüberwachung durch einen Sicherheitsdienstes<br>
                          • hohe Brandschutz-Maßnahmen<br>
                          • u.v.m.
                        </v-flex>
                        <v-flex xs6 sm5>
                          Wir freuen uns Ihnen folgende Dienstleistungen durch das Rechenzentrum anbieten zu können:
                          <br><br>
                          • Webhosting<br>
                          • Dedicated Server<br>
                          • E-Mail Dienste<br>
                          • Monitoring<br>
                          • Backup - Lösungen (Owncloud/ Nextcloud)<br>
                          • Contao Hosting<br>
                          • u.v.m.<br>
                          <br><br>
                          Sprechen Sie uns an, wir unterstützen Sie!
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="white"
                        flat
                        @click="dialog3 = false"
                      >
                        Schliessen
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-layout justify-center>
                  <v-flex xs6>
                    <div class="borderedo"></div>
                  </v-flex>
                </v-layout>
                <v-card-text class="title">Hosting</v-card-text>
                <v-btn
                  flat
                  color="white"
                  large
                  @click="dialog3=true"
                  class="mb-5 text-none"
                > Mehr Wissen
                </v-btn>
              </v-card>
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <v-card dark tile flat color="transparent" class="text-xs-center">
              <v-dialog
                v-model="dialog4"
                width="1000"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="transparent"
                    large
                    v-on="on"
                    class="mb-5"
                  >
                    <v-icon class="largeicon">how_to_reg</v-icon>
                  </v-btn>
                </template>
                <v-card color="#000012">
                  <v-card-title
                    class="display-3 edocolor font-weight-bold text-xs-center"
                  ><v-img src="static/ueberuns.jpg" max-height="300px">
                    <v-container fill-height>
                      <v-layout align-center>
                        <!-- Horizontal: text-xs-center -->
                        <v-flex xs12 text-xs-center>
                          Rundumsorglospaket
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                  </v-card-title>
                  <v-card-text class="white--text headline">
                    <span itemprop="description">
Durch unser Rundum Sorglos Paket können Sie sich entspannt zurücklegen – Sie sagen uns, welche Vorstellung Sie haben und wir realisieren diese. Von A wie Anfang bis Z wie Zupport. Wir wissen, dass Support nicht mit Z geschrieben wird, aber unser Service geht weit über das S hinaus. Mit unserer Software, die wir individuell für Sie entwickeln, brauchen Sie sich nicht arrangieren, denn unsere Software wird zu Ihrer Software, perfekt auf Sie abgestimmt. Sie wissen zwar, was Ihre Anwendung können muss, jedoch noch nicht wie die Gestaltung sein soll? Kein Problem, in unserem Rundum Sorglos Paket sind auch unsere Grafiker im vollem Umfang für Sie da – ob unsere Grafiker Ihr Design perfektionieren oder ein Design vorschlagen, hängt ganz von Ihnen ab, wie weit Sie Unterstützung wünschen.
Lassen Sie uns gemeinsam, ihr perfektes Paket besprechen.
                    </span>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="white"
                      flat
                      @click="dialog4 = false"
                    >
                      Schliessen
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-layout justify-center>
                <v-flex xs6>
                  <div class="borderedo"></div>
                </v-flex>
              </v-layout>
              <v-card-text class="title">Rundumsorglospaket</v-card-text>
              <v-btn
                flat
                color="white"
                large
                @click="dialog4=true"
                class="mb-5 text-none"
              > Mehr Wissen
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <v-layout row>
      <v-img src="static/edologic_produkte.png" min-height="594px" class="mb-5">
        <v-layout fill-height>
          <v-container>
            <v-layout pa-2 row class="lightbox white--text hidden-xs-only">
              <v-flex xs12 sm12 md12 lg12 text-xs-left>
                <div class="display-3 font-weight-bold">
                  unsere Produkte.<br>
                  begeistern.<br>
                  jeden.
                </div>
                <div class="headline font-weight-light white--text mt-3">
                  Geniale Produkte finden Sie hier
                </div>
              </v-flex>
            </v-layout>
            <v-layout pa-2 row class="lightbox white--text hidden-sm-and-up">
              <v-flex xs12 sm12 md12 lg12 text-xs-right>
                <div class="display-2 font-weight-bold">
                  unsere Produkte.<br>
                  begeistern.<br>
                  jeden.
                </div>
                <div class="headline font-weight-light white--text mt-3">
                  Geniale Produkte finden Sie hier
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-start class="mt-5">
              <v-flex xs8 sm3 class="ma-3 hand">
                <v-card tile flat color="black" class="pa-3">
                  <v-img src="static/surfandscan_logo.png" @click="routeTo('/SurfandScan')"> </v-img>
                </v-card>
              </v-flex>
              <v-flex xs8 sm3 class="ma-3 hand">
                <v-card dark tile flat color="black" class="pa-3">
                  <v-img src="static/examenis_logo.png" @click="routeTo('/SurfandScan')"> </v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-img>
    </v-layout>

    <v-card flat color="transparent" class="mb-5">
      <v-layout row algin-center fill-height>
        <v-container>
          <v-layout row class="ma-5">
            <v-flex xs12>
              <v-card dark tile flat color="transparent" class="text-xs-center mb-5">
                <v-card-text class="display-3 font-weight-bold">Erfolgsgeschichten</v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-flex xs12>
              <v-card dark tile flat color="transparent" class="text-xs-center mb-5">
                <v-timeline dark>
                  <v-timeline-item
                    v-for="(item, i) in titles"
                    :key="i"
                    :color="item.color"
                    large
                    class="my-5"
                  >
                    <template v-slot:opposite>
        <span
          :class="`display-3 font-weight-bold ${item.color}--text`"
          v-text="item.title"
        ></span>
                    </template>
                    <div class="py-5 my-5">
                      <h2 :class="`display-1 text-xs-left font-weight-bold mb-3 ${item.color}--text`">{{item.headline}}</h2>
                      <div class="white--text title text-xs-left"  v-text="item.text">
                      </div>
                    </div>
                  </v-timeline-item>
                </v-timeline>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </v-card>
    <v-card flat color="transparent" min-height="800px">
      <v-layout row algin-center fill-height>
        <v-container>
          <v-layout row class="ma-5">
            <v-flex xs12>
              <v-card dark tile flat color="transparent" class="text-xs-center mb-5">
                <v-card-text class="display-3 font-weight-bold">Geniale Projekte mit</v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-space-around class="mb-3">
            <v-flex xs10 sm4 md3 class="pa-3 hand">
              <v-card dark tile flat color="transparent">
                <v-img src="static/logo_volkswagen.png" @click="routeToGlobal('https://www.volkswagenag.com')"></v-img>
              </v-card>
            </v-flex>
            <v-flex xs10 sm4 md3 class="pa-3 hand">
              <v-card dark tile flat color="transparent">
                <v-img src="static/logo_creditreform.png" @click="routeToGlobal('https://www.creditreform-rating.de/')"></v-img>
              </v-card>
            </v-flex>
            <v-flex xs10 sm4 md3 class="pa-3 hand">
              <v-card dark tile flat color="transparent">
                <v-img src="static/logo_easy.png" @click="routeToGlobal('https://easy-software.com/de/')"></v-img>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-space-around>
            <v-flex xs10 sm4 md3 class="pa-3 hand">
              <v-card dark tile flat color="transparent">
                <v-img src="static/logo_schuetzundlicht.png" @click="routeToGlobal('https://www.schuetz-licht.de/')"></v-img>
              </v-card>
            </v-flex>
            <v-flex xs10 sm4 md3 class="pa-3 hand">
              <v-card dark tile flat color="transparent">
                <v-img src="static/logo_treumerkur.png" @click="routeToGlobal('https://www.treumerkur.de')"></v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </v-card>
    <v-card flat color="transparent" min-height="850px">
      <v-layout row algin-center>
        <v-container>
          <v-flex xs12>
            <v-layout row wrap justify-space-around class="mb-5">
              <v-flex xs12 sm5 md4>
                <v-card dark tile flat color="blue darken-4" class="text-xs-left">
                  <v-card-text class="display-3 font-weight-bold">Wo denn?</v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <div itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
                  <v-card-text class="headline  white--text">
                    <span class="font-weight-bold"><span itemprop="name">edologic GmbH</span></span>
                    <br><br>
                    <span itemprop="streetAddress">In der Hardt 3</span><br>
                    <span itemprop="postalCode">42399</span> <span itemprop="addressLocality"> Wuppertal</span>
                    <br><br>
                    <span itemprop="telephone">+49 202 - 947 996 20</span><br>
                    <a href="mailto:info@edologic.de" itemprop="email" style="color: white; text-decoration: none">info@edologic.de</a>
                  </v-card-text>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-space-around class="mt-5">
              <v-flex xs12 sm5 md4 class="mt-5">
                <v-card dark tile flat color="blue darken-4">
                  <v-card-text class="display-3 font-weight-bold">
                    Wann denn?</v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 md6 class="mt-5">
                <div itemscope itemtype="http://schema.org/OpeningHoursSpecification">
                  <v-card-text>
                    <v-layout row justify-space-between>
                      <v-flex xs6 class="white--text headline">
                        <link itemprop="dayOfWeek" href="http://schema.org/Monday"/>
                        Montag:
                      </v-flex>
                      <v-flex xs6 class="white--text headline">
                        <time itemprop="opens" content="09:00:00">
                          9:00
                        </time>
                        -
                        <time itemprop="closes" content="17:00:00">
                          17:00
                        </time>
                      </v-flex>
                    </v-layout>
                    <v-layout row justify-space-between>
                      <v-flex xs12 class="white--text headline">
                        <link itemprop="dayOfWeek" href="http://schema.org/Tuesday"/>
                        Dienstag:
                      </v-flex>
                      <v-flex xs12 class="white--text headline">
                        <time itemprop="opens" content="09:00:00">
                          9:00
                        </time>
                        -
                        <time itemprop="closes" content="17:00:00">
                          17:00
                        </time>
                      </v-flex>
                    </v-layout>
                    <v-layout row justify-space-between>
                      <v-flex xs6 class="white--text headline">
                        <link itemprop="dayOfWeek" href="http://schema.org/Wednesday"/>
                        Mittwoch:
                      </v-flex>
                      <v-flex xs6 class="white--text headline">
                        <time itemprop="opens" content="09:00:00">
                          9:00
                        </time>
                        -
                        <time itemprop="closes" content="17:00:00">
                          17:00
                        </time>
                      </v-flex>
                    </v-layout>
                    <v-layout row justify-space-between>
                      <v-flex xs6 class="white--text headline">
                        <link itemprop="dayOfWeek" href="http://schema.org/Thursday"/>
                        Donnerstag:
                      </v-flex>
                      <v-flex xs6 class="white--text headline">
                        <time itemprop="opens" content="09:00:00">
                          9:00
                        </time>
                        -
                        <time itemprop="closes" content="17:00:00">
                          17:00
                        </time>
                      </v-flex>
                    </v-layout>
                    <v-layout row justify-space-between>
                      <v-flex xs6 class="white--text headline">
                        <link itemprop="dayOfWeek" href="http://schema.org/Friday"/>
                        Freitag:
                      </v-flex>
                      <v-flex xs6 class="white--text headline">
                        <time itemprop="opens" content="09:00:00">
                          9:00
                        </time>
                        -
                        <time itemprop="closes" content="15:00:00">
                          15:00
                        </time>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-container>
      </v-layout>
    </v-card>
  </v-content>
</template>

<script>
  // import Vue from 'vue'

  export default {
    metaInfo: {
      title: 'edologic GmbH - Geniale Projekte beginnen hier',
      // override the parent template and just use the above title only
      titleTemplate: null,
      meta: [
        {
          name: 'description',
          content: 'Innovative Softwarelösungen und atemberaubendes Designs von der edologic – Ihrem Partner für professionelle Softwareentwicklung mit bemerkenswertem Design'
        }]
    },
    data () {
      return {
        dialog: false,
        dialog2: false,
        dialog3: false,
        dialog4: false,
        titles: [
          {
            color: 'cyan',
            title: 'Kalibiriersoftware',
            headline: 'Enorme Zeitersparnis',
            text: 'Die Entwicklung der Kalibriersoftware, bringt dem Kunden eine enorme Zeitersparnis. ' +
              'Schnellere und effizientere Arbeit wird gewährleistet. Durch die Kalibriersoftware haben wir die Qualität und die Quantität gesteigert. '
          },
          {
            color: 'green',
            title: 'Information-Screensaver',
            headline: 'Informationen in sekundenschnelle auf tausenden Bildschirmen',
            text: 'Automobilbauer aus Wolfsburg - Zehntausende Rechner, die in wenig Zeit Creative Content benötigen. Die Lösung, ein Informationen Scrennsaver.' +
              'Das Bild auf dem Server erneuern und in nur einem Augenblick, erhalten über 20.000 Bildschirme einen neuen Scrennsaver. Ist das Magie? — Nein, das ist logic, edologic. '
          },
          {
            color: 'pink',
            title: 'Finanzportal',
            headline: 'Finanzkommunikation – sicher und schnell',
            text: 'Laden Sie schnell und einfach Ihren Jahresabschluss für ausgewählte \n' +
              'Geschäftspartner und Banken hoch und erhalten Sie einen kostenlosen \n' +
              'Bonitätscheck!'
          },
          {
            color: 'amber',
            title: 'Webshopentwicklung',
            headline: 'Konfigurieren eines Produktes direkt im Browser',
            text: 'Transparente Kosten für den Kunden, ausreichende Informationen für den Dienstleister. Wenn Online-Shopping für alle Spaß macht'
          },
          {
            color: 'orange',
            title: 'App-Entwicklung für Sprachassistenten',
            headline: 'Stelle die Heizung im Wohnzimmer höher',
            text: 'Das Smart Home logisch smarter machen mit der edologic. ' +
              'Durch App-Entwicklung problemlos Ihr Produkt mit den Sprachassistenten verbinden.'
          }
        ]
      }
    },
    methods: {
      routeToGlobal (url) {
        window.open(url, '_new')
      },
      routeTo (url) {
        this.$router.push(url)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newSite.vue